export const getLabelOrderProductErrorMessage = {
	NotAuthorizedException: {
		messageKey: "edit_error_NotAuthorizedException",
	},
	EntityStatusException: {
		messageKey: "entityStatusExceptionError",
	},
	EntityRoleException: {
		messageKey: "entityOperationRoleExcepectionError",
	},
	EntityOperatorException: {
		messageKey: "entityOperationStoreExcepectionError",
	},
	ProductNotFoundException: {
		messageKey: "Product not found.",
	},
} as const

export const postOrderErrorMessages = {
	NotAuthorizedException: {
		messageKey: "edit_error_NotAuthorizedException",
	},
	EntityStatusException: {
		messageKey: "entityStatusExceptionError",
	},
	EntityRoleException: {
		messageKey: "entityOperationRoleExcepectionError",
	},
	EntityOperatorException: {
		messageKey: "entityOperationStoreExcepectionError",
	},
} as const
